import { CopyOutlined } from '@ant-design/icons';
import Spinner from '../Spinner';
import { TooltipButton } from './../TooltipButton';
import React, { useCallback, useState } from 'react';

const ClipboardCopyButton = ({ data, toolTipText, onClickCallback }) => {
  const [tooltipText, setTooltipText] = useState(toolTipText ?? 'Copy raw file');
  const [loading, setLoading] = useState(false);

  const handleCopyFileContent = useCallback(
    (event) => {
      setLoading(true);
      navigator.clipboard.writeText(data).then(() => {
        setTooltipText('Copied');
        setLoading(false);
        setTimeout(() => {
          setTooltipText('Copy raw file');
        }, 1000);
      });
      onClickCallback?.(event);
    },
    [data, setLoading, setTooltipText]
  );

  return (
    <>
      <TooltipButton
        onClick={handleCopyFileContent}
        tooltipText={tooltipText}
        type={'text'}
        className="icon-circle copy-btn"
        icon={
          <>
            {loading ? (
              <Spinner size={16} />
            ) : (
              <CopyOutlined />
              // <svg
              //   aria-hidden="true"
              //   focusable="false"
              //   role="img"
              //   className="octicon octicon-copy"
              //   viewBox="0 0 16 16"
              //   width="16"
              //   height="16"
              //   fill="currentColor"
              //   style={{
              //     display: 'inline-block',
              //     userSelect: 'none',
              //     verticalAlign: 'text-bottom',
              //     overflow: 'visible',
              //   }}
              // >
              //   <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path>
              //   <path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path>
              // </svg>
            )}
          </>
        }
      ></TooltipButton>
    </>
  );
};

export default ClipboardCopyButton;
